// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import styles from "./styles/main.scss";
import SplitText from './lib/gsap/bonus-files-for-npm-users/SplitText';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	el: "#app",
	router,
	components: { App },
	template:
		'<App :backgroundUrl="backgroundUrl" :hoveredTo="hoveredTo" :companies="companies"/>',
	data() {
		return {
			backgroundUrl: "",
			hoveredTo: "",
			companies: []
		};
	},
	methods: {
		onHoverTo(path) {
			this.hoveredTo = path;
		},
		offHoverTo(path) {
			this.hoveredTo = "";
		},
		setBackground(url) {
			console.log("setBackground", url);
			this.backgroundUrl = url;
		}
	},
	created() {
		
	}
});



// WEBPACK FOOTER //
// ./src/main.js